import {updateFactory} from '@modifi/redux'
import {
  NewPersonView,
  ExistingPersonView,
  getAuthenticatedThemisClient,
} from '@modifi/onboarding-api-clients'
import {DataProvenance} from '@modifi/enums'

import {NestedError} from '../../../utils'

const apiClient = getAuthenticatedThemisClient()

const {actions} = updateFactory({
  rootSelector: state => state?.modules?.persons?.create,
  actionNamePrefix: 'modules/persons/create',
  // @ts-expect-error returning person view
  submitRequest:
    (a, data: NewPersonView) =>
    async (
      dispatch
    ): Promise<
      ExistingPersonView & {externalId: NonNullable<ExistingPersonView['externalId']>}
    > => {
      dispatch(a.pendingAction())
      try {
        const result = await apiClient.Person.create({
          body: {
            ...data,
            politicallyExposed: data.politicallyExposed ?? false,
            dataProvenance: DataProvenance.USER_INPUT,
          },
        }).then(res => res.data() as ExistingPersonView)

        dispatch(a.successAction())

        return result as ExistingPersonView & {
          externalId: NonNullable<ExistingPersonView['externalId']>
        }
      } catch (error: any) {
        dispatch(a.errorAction(error))
        throw new NestedError(`Error while calling Person.create endpoint`, error)
      }
    },
})

export const {aSubmit: aCreatePerson} = actions
